/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable constructor-super */
import wxHost from './wx'
import { wgs84ToGcj02 } from './geo'
import { getEntryInfo } from '@/utils'
import { MINIKEY } from '@/config/constant'
import { AppBaseInfoType } from '../types/user'
import { LandscapeScreenSafeAreaInfo } from '@/types/app'
import { setGlobelHeader, getGlobelHeader } from '@/utils/request'
import {
  IOS_USERAGENT,
  ANDROID_USERAGENT,
  FARM_USERAGENT,
  XAPC_USERAGENT,
  XAPC4_USERAGENT,
  AGRI_USERAGENT,
  FARM2_USERAGENT,
  FARM3_USERAGENT,
  XAGAR_USERAGENT,
  TABLET_USERAGENT_XAPC,
} from '@/config/app'

export interface OpenNewPageParams {
  url: string // url链接
  title?: string // 标题栏文案
  showTopBar?: boolean // 是否显示标题栏
  isFullScreenOnLandscape?: boolean //  横屏状态下是否全屏显示， false：webView大小限制为全屏的 8/12， 竖屏该参数不生效
  backgroundColor?: string // 背景颜色，默认为白色：0xFFFFFF
}
export interface NavigationInfo {
  address: string
  lng: number
  lat: number
}
export interface ShareActionOption {
  title: string
  desc: string
  image: string // base64编码
  url: string
  type: 0 | 1 | 2 // 0 分享到微信  1 分享到朋友圈  2 复制链接
}
export type NFProgrameVersions = 0 | 1 | 2 // 0正式版 1测试版  2体验版
export interface ShareToWeChatParams {
  iconStr: string
  title: string
  description: string
  shareUrl: string
}
export abstract class IHost {
  /**
   * 客户端回调的【状态栏】的高度，需要除以window.devicePixelRatio
   * @param fn
   */
  abstract getStatusBarHeight(fn?: (px: number) => void): void
  abstract goAppBack(): void
  abstract postSobotChat(): void
  abstract startLocation(status: boolean, cb?: (lng: number, lat: number) => void): void
  abstract postAddDevice(fn?: (serial_number: string) => void): void
  abstract postCallPhone(telephone: string, name?: string): void
  abstract postMapNavigation(obj: NavigationInfo | string): void
  abstract onPay(orderNum: string): void
  abstract openBrowser(url: string, isImg?: boolean): void
  abstract onLogin(): void
  abstract postMessage?<T>(data?: T): void
  /** 在app中暂存数据，只提供字符串，用户跨应用，跨站点传递数据 */
  abstract setAppStorage(payload: string): void
  abstract getNFAppVersion(): Promise<string>
  abstract openMiniProgram(id: string, path: string, version: NFProgrameVersions): void
  abstract getAppBaseInfo(): Promise<AppBaseInfoType>
  abstract getFaultReportCache(): Promise<string>
  abstract deleteFaultReport(id: string): Promise<void>
  abstract getFaultReportImage(sn: string): Promise<string>
  abstract setOfflinePageEnable(enable: boolean): Promise<void>
  abstract getDisplayMode(): Promise<string>
  abstract getLandscapeScreenSafeArea(): Promise<LandscapeScreenSafeAreaInfo>
  abstract openCameraToScanQrCode(str: string): Promise<string>
  abstract openNewPage(params: string | OpenNewPageParams): void
  abstract saveImage(str: string): Promise<string>
  abstract shareAction(option: ShareActionOption): Promise<void>
  abstract shareToMoments(
    params: ShareToWeChatParams | string,
    title?: string,
    description?: string,
    shareUrl?: string
  ): void
  abstract shareToWeChat(
    params: ShareToWeChatParams | string,
    title?: string,
    description?: string,
    shareUrl?: string
  ): void
}

function checkUserAgent(userAgent: string | string[]) {
  if (Array.isArray(userAgent)) {
    return userAgent.some((ua) => {
      return navigator.userAgent.toLowerCase().indexOf(ua) > -1
    })
  }
  return navigator.userAgent.toLowerCase().indexOf(userAgent) > -1
}

/** IOS端 */
export const isIos = checkUserAgent(IOS_USERAGENT)
/** Android端 */
export const isAndrod = checkUserAgent(ANDROID_USERAGENT)
/** 农场 */
export const isFarmApp = checkUserAgent(FARM_USERAGENT)
export const isFarm2App = checkUserAgent(FARM2_USERAGENT)
export const isFarm3App = checkUserAgent(FARM3_USERAGENT)
/** 农服 */
export const isAgriApp = checkUserAgent(AGRI_USERAGENT)
/* 自驾仪 */
export const isXapc = checkUserAgent(XAPC_USERAGENT)
export const isXapc4 = checkUserAgent(XAPC4_USERAGENT)
export const isXapcTabLet = checkUserAgent(TABLET_USERAGENT_XAPC)
// 无人车
export const isXagarApp = checkUserAgent(XAGAR_USERAGENT)

export const isApp = isIos || isAndrod
export function getAppName() {
  if (isAgriApp) {
    return '极飞农服'
  }
  if (isFarmApp || isFarm2App || isFarm2App) {
    return '极飞农场'
  }
  if (isXapc || isXapc4) {
    return '极飞农机'
  }
  if (isXagarApp) {
    return '极飞无人车'
  }
  return ''
}
export function judgeHasGetBaseInfo(): boolean {
  // 添加注释
  if (isAndrod) {
    const android: Record<string, any> | undefined = window?.android
    return !!android?.getAppBaseInfo
  } else if (isIos) {
    const messageHandlers = window.webkit.messageHandlers
    return !!messageHandlers?.getAppBaseInfo
  } else {
    return false
  }
}

class Observer {
  subscribers: Record<string, Array<() => void>>
  constructor() {
    this.subscribers = {}
  }

  addSubscriber(event: string | number, fn: () => void) {
    const subs = this.subscribers[event] || (this.subscribers[event] = [])
    subs.push(fn)
  }

  clearSubscriber(event: string) {
    this.subscribers[event] = []
  }

  removeSubscriber(event: string, fn: () => void) {
    const subs = this.subscribers[event]
    if (subs === undefined || subs.length === 0) return
    subs.splice(subs.indexOf(fn), 1)
  }

  public(event: string, ...avg: unknown[]) {
    const subs = Array.from(this.subscribers[event])
    while (subs.length) {
      // eslint-disable-next-line prefer-rest-params
      typeof subs[0] === 'function' && subs[0].apply(null, avg as [])
      subs.pop()
    }
  }
}

const mockFn = (...arg: unknown[]) => console.log('mock-app', arg)

const mockGetStatusBarHeight = (fn: (px: number) => void) => {
  fn(0)
}

const mockGetNFAppVersion1 = () => Promise.resolve('614')
const parseAppBaseInfo = (data: string | Record<string, unknown>) => {
  try {
    if (typeof data === 'string') {
      const value = JSON.parse(
        data
          .replace(/(\n|\r|\t|\r\n|↵)/g, '')
          .replace(/\\/g, '\\\\')
          .replace(/[^\0-~]/g, function (ch) {
            return '\\u' + ('0000' + ch.charCodeAt(0).toString(16)).slice(-4)
          })
      )
      return value
    }
    return data
  } catch (error) {
    console.log('error', error)
    return error
  }
}
const parseLandscapeInfo = (data: string) => {
  let value: LandscapeScreenSafeAreaInfo = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  }
  try {
    const parseData = JSON.parse(data)
    const devicePixelRatio = window.devicePixelRatio
    parseData.top = parseData.top / devicePixelRatio
    parseData.bottom = parseData.bottom / devicePixelRatio
    parseData.left = parseData.left / devicePixelRatio
    parseData.right = parseData.right / devicePixelRatio
    value = {
      ...value,
      ...parseData,
    }
  } catch (error) {
    console.log('error', error)
  }
  return value
}
const mockLocation = (status: boolean, cb?: (lng: number, lat: number) => void) => {
  if (cb) {
    setTimeout(() => {
      const EntryData = getEntryInfo()
      const lng = EntryData?.lng || 113.23
      const lat = EntryData?.lat || 23.16
      cb(Number(lng), Number(lat))
    }, 100)
  }
}
const mockPostAddDevice = (fn: (serial_number: string) => void) => {
  setTimeout(() => {
    fn('122B280236')
  }, 0)
}

function getHostApp(): IHost {
  return {
    getStatusBarHeight: mockGetStatusBarHeight,
    goAppBack: mockFn,
    startLocation: (status, cb) => {
      if (wxHost.isMiniprogram || wxHost.isWeixin) {
        wxHost.startLocation(status, cb)
      } else {
        mockLocation(status, cb)
      }
    },
    postSobotChat: mockFn,
    postAddDevice: mockPostAddDevice,
    postCallPhone: (...avg) => {
      if (wxHost.isMiniprogram) {
        wxHost.postCallPhone(...avg)
      } else {
        return mockFn(...avg)
      }
    },
    postMapNavigation: (config) => {
      if (wxHost.isMiniprogram) {
        if (typeof config === 'string') {
          try {
            const mConfig = JSON.parse(config) as NavigationInfo
            const gcj = wgs84ToGcj02(mConfig)
            wxHost.postMapNavigation({
              ...mConfig,
              ...gcj,
            })
          } catch (error) {
            console.log('postMapNavigation', error)
          }
        } else {
          const gcj = wgs84ToGcj02(config)
          wxHost.postMapNavigation({
            ...config,
            ...gcj,
          })
        }
      } else {
        return mockFn(config)
      }
    },
    onPay: (...avg) => {
      if (wxHost.isMiniprogram) {
        wxHost.onPay(...avg)
      } else {
        return mockFn(...avg)
      }
    },
    openBrowser: (...avg) => {
      if (wxHost.isMiniprogram) {
        wxHost.onOpenFile(...avg)
      } else {
        return mockFn(...avg)
      }
    },
    onLogin: mockFn,
    postMessage: (data) => {
      if (wxHost.isMiniprogram) {
        wxHost.postMessage(data)
      } else {
        return mockFn(data)
      }
    },
    setAppStorage: mockFn,
    getNFAppVersion: mockGetNFAppVersion1,
    openMiniProgram: (id, path, version) => {
      if (wxHost.isMiniprogram) {
        wxHost.navigateTo(path)
      } else {
        return mockFn(id, path, version)
      }
    },
    getAppBaseInfo: () => Promise.resolve({ token: '', platform: 'tablet' }),
    getFaultReportCache: () => {
      const str = JSON.stringify([
        {
          deviceId: 'A44002B000351303231333534',
          deviceName: 'P40_ios_2.0协议',
          imageNames: ['1675911391', '1675911399'],
          timstamp: 1675911406,
          deviceSeries: 0,
          deviceSn: 'V50PP20220425007',
          faultDescription: '有时候想办法也是不太清楚',
          deviceModel: 'UAV13',
        },
      ])
      return Promise.resolve(str)
    },
    deleteFaultReport: (data: string) => undefined,
    getFaultReportImage: async (sn: string) => {
      if (sn === '1675911391') {
        return `data:image/png;base64,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`
      } else if (sn === '1675911399') {
        return `data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAYdJREFUWEftlctKQ0EQRE9U0IWvT/MrBI2IK8WFT9wLihH8Cn9MEHUhgg9KeqQzztyZMYG4uAOXhGS6urq6q++AGZ/BjPPTE+gV6BX41wrM2454n3BXdOLUKBDufDYSqYrrIrAJLALXwBwgArUkhKvnA9gHnoHbVAExAcklybeAC0soAucuuETCYx4De0bkELgDQo5vyByBA0DPA7AGjIBTC1ZVORLCk1oqQve3gSdg3Yq4KhEIpJQgAEi+VeAGOOtQwhdzAgwt+YorQHfGyKdmIFzSZw5IMnolUpXHxJW4ikBQIZYyp4SfrVrCPzFdLqiR1Hu8tWXJIYyd0iVtGEzF+IHzPY9b9cuJLYtIwbHEmmqdXfN6zbCOkaghkJuJF2DJ0F6B5Qa7Vs1Aqh3hNymxAzyareTzkk2Tm7xWgRDsV+yRbTn1+dJ2RLHnXVXVvmuClxeADdt898Bbyucl0FYFPJ72hJaRjv9eyvmnIUyBhnbov5Y35dQINFWauzxJC3oCvQJTUeAL99BsIVEm0dAAAAAASUVORK5CYII=`
      }
      return ''
    },
    setOfflinePageEnable: (enable = false) => Promise.resolve(undefined),
    getDisplayMode: () => Promise.resolve('Portrait'),
    getLandscapeScreenSafeArea: () =>
      Promise.resolve({
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      }),
    openCameraToScanQrCode: () => Promise.resolve('111'),
    openNewPage(params: OpenNewPageParams) {
      console.log('222', params, 222)
      window.open(params.url)
    },
    saveImage: (data: string) => Promise.resolve(undefined),
    shareAction: (option: ShareActionOption) => Promise.resolve(undefined),
    shareToMoments: mockFn,
    shareToWeChat: mockFn,
  }
}

export type AndroidAppHost = IHost & {
  setNavigationBarStatus: (fitsWindow: boolean, color: string) => number
}

class AndroidApp extends Observer implements IHost {
  vm: AndroidAppHost
  constructor() {
    super()
    this.vm = window.android as AndroidAppHost
  }

  handdleResult(result: string) {
    if (typeof result === 'string') {
      return JSON.parse(result)
    }
    return result
  }

  /**
   * 获取statusBar的高度
   */
  getStatusBarHeight(fn: (px: number) => void): void {
    window.statusBarHeight = (px) => {
      fn(px)
    }
    if (!this.vm || !this.vm.getStatusBarHeight) {
      // 兼容需要从其他页面跳转到该项目时，通过传参的方式设置导航条高度的值
      const EntryData = getEntryInfo()
      window.statusBarHeight(EntryData.statusHeight ? Number(EntryData.statusHeight) : 0)
    } else {
      this.vm.getStatusBarHeight()
    }
  }

  /**
   * 获取新增设备guid就是序列号或者id之类的唯一标识
   */
  postAddDevice(fn: (serial_number: string) => void): void {
    window.addDevice = (serial_number) => {
      fn(serial_number)
    }
    this.vm.postAddDevice()
  }

  goAppBack() {
    this.vm.goAppBack()
  }

  /**
   * 需要接口确定这是持续调用还是
   * @param {Boolean} status true的时候，需要回调onLocationChange方法;false时候，停止回调
   */
  startLocation(status: boolean, cb?: (lng: number, lat: number) => void) {
    if (cb) {
      window.onLocationChange = cb
    }
    if (!this.vm || !this.vm.startLocation) {
      // 兼容需要从其他页面跳转到该项目时，通过传参的方式设置经纬度
      const EntryData = getEntryInfo()
      window.onLocationChange(Number(EntryData.lng || 0), Number(EntryData.lat || 0))
      return
    }
    this.vm.startLocation(status)
  }

  //   打开在线客服
  postSobotChat() {
    this.vm.postSobotChat()
  }

  // 拨号
  postCallPhone(telephone: string) {
    this.vm.postCallPhone(telephone)
  }

  // 导航
  postMapNavigation(obj: NavigationInfo) {
    const str = JSON.stringify(obj)
    this.vm.postMapNavigation(str)
  }
  // 支付维修单
  onPay(orderNum: string) {
    this.vm.onPay(orderNum)
  }
  // 打开浏览器
  openBrowser(url: string) {
    this.vm.openBrowser(url)
  }
  onLogin() {
    this.vm.onLogin()
  }
  setAppStorage(payload: string) {
    try {
      this.vm.setAppStorage(payload)
    } catch (error) {
      console.log('error', error)
    }
  }
  getNFAppVersion(): Promise<string> {
    return new Promise((resolve) => {
      window.setNFAppVersion = (version: string) => {
        resolve(version)
      }
      if (!this.vm?.getNFAppVersion) {
        resolve('')
      }
      this.vm.getNFAppVersion()
    })
  }
  openMiniProgram(id: string, path: string, version: NFProgrameVersions) {
    this.vm.openMiniProgram(id, path, version)
  }
  getAppBaseInfo(): Promise<AppBaseInfoType> {
    return new Promise((resolve) => {
      window.responseAppBaseInfo = (data: string) => {
        resolve(parseAppBaseInfo(data))
      }
      if (!this.vm.getAppBaseInfo) {
        resolve(null)
      }
      this.vm.getAppBaseInfo()
    })
  }
  getFaultReportCache(): Promise<string> {
    return new Promise((resolve) => {
      if (!this.vm.getFaultReportCache) {
        resolve('')
        return
      }
      const data = this.vm.getFaultReportCache()
      resolve(data)
    })
  }
  deleteFaultReport(id: string): undefined {
    if (!this.vm.deleteFaultReport) {
      return undefined
    }
    this.vm.deleteFaultReport(id)
  }
  getFaultReportImage(val: string) {
    // 安卓暂不实现该功能
    return Promise.resolve('')
  }
  setOfflinePageEnable(enable = false) {
    if (!this.vm.setOfflinePageEnable) {
      return Promise.resolve(undefined)
    }
    return this.vm.setOfflinePageEnable(enable)
  }
  getDisplayMode(): Promise<string> {
    return new Promise((resolve) => {
      window.responseGetDisplayMode = (mode: string) => {
        resolve(mode)
      }
      if (!this.vm.getDisplayMode) {
        // 不存在时默认竖屏
        resolve('Portrait')
      }
      this.vm.getDisplayMode()
    })
  }
  getLandscapeScreenSafeArea(): Promise<LandscapeScreenSafeAreaInfo> {
    return new Promise((resolve) => {
      window.responseLandscapeScreenSafeArea = (data) => {
        resolve(parseLandscapeInfo(data))
      }
      if (!this.vm.getLandscapeScreenSafeArea) {
        // 不存在时
        resolve(null)
      }
      this.vm.getLandscapeScreenSafeArea()
    })
  }
  // 安卓设置底部操作栏
  setNavigationBarStatus(fitsWindow: boolean, color: string) {
    this.vm.setNavigationBarStatus(fitsWindow, color)
  }
  // 打开二维码扫描
  openCameraToScanQrCode(title: string): Promise<string> {
    return new Promise((resolve) => {
      window.onOpenCameraToScanQrCodeResponse = (result: string) => {
        resolve(result)
      }
      this.vm.openCameraToScanQrCode(title)
    })
  }
  // 打开新的webview
  openNewPage(params: OpenNewPageParams) {
    if (!this.vm.openNewPage) {
      return Promise.resolve(undefined)
    }
    return this.vm.openNewPage(JSON.stringify(params))
  }
  saveImage(str: string) {
    if (!this.vm.saveImage) {
      return Promise.resolve(undefined)
    }
    return this.vm.saveImage(str)
  }
  shareAction(option: ShareActionOption) {
    if (!this.vm.shareAction) {
      return Promise.resolve(undefined)
    }
    return this.vm.shareAction(option)
  }
  // 分享到朋友圈
  shareToMoments(params: ShareToWeChatParams) {
    if (!this.vm.shareToMoments) {
      return Promise.resolve(undefined)
    }
    console.log('params222', params)
    return this.vm.shareToMoments(params.iconStr, params.title, params.description, params.shareUrl)
  }
  // 分享到微信
  shareToWeChat(params: ShareToWeChatParams) {
    if (!this.vm.shareToWeChat) {
      return Promise.resolve(undefined)
    }
    return this.vm.shareToWeChat(params.iconStr, params.title, params.description, params.shareUrl)
  }
}

class IosApp extends Observer implements IHost {
  goAppBack() {
    window.webkit.messageHandlers.goAppBack.postMessage('')
  }

  /**
   * 获取statusBar的高度
   */
  getStatusBarHeight(fn: (px: number) => void) {
    window.statusBarHeight = (px) => {
      fn(px)
    }
    if (!window.webkit.messageHandlers?.getStatusBarHeight?.postMessage) {
      const EntryData = getEntryInfo()
      window.statusBarHeight(EntryData.statusHeight ? Number(EntryData.statusHeight) : 0)
    } else {
      window.webkit.messageHandlers.getStatusBarHeight.postMessage('')
    }
  }

  /**
   * 获取新增设备guid就是序列号或者id之类的唯一标识
   */
  postAddDevice(fn: (serial_number: string) => void) {
    window.addDevice = (serial_number) => {
      fn(serial_number)
    }
    window.webkit.messageHandlers.postAddDevice.postMessage('')
  }

  startLocation(status: boolean, cb?: (lng: number, lat: number) => void) {
    if (cb) {
      window.onLocationChange = cb
    }
    if (!window.webkit.messageHandlers?.startLocation?.postMessage) {
      // 兼容需要从其他页面跳转到该项目时，通过传参的方式设置经纬度
      const EntryData = getEntryInfo()
      window.onLocationChange(Number(EntryData.lng || 0), Number(EntryData.lat || 0))
      return
    }
    window.webkit.messageHandlers.startLocation.postMessage(status)
  }

  postSobotChat() {
    window.webkit.messageHandlers.postSobotChat.postMessage('')
  }

  // 拨号
  postCallPhone(telephone: string) {
    window.webkit.messageHandlers.postCallPhone.postMessage(telephone)
  }
  // 导航
  postMapNavigation(obj: NavigationInfo) {
    window.webkit.messageHandlers.postMapNavigation.postMessage(obj)
  }
  // 支付维修单
  onPay(orderNum: string) {
    window.webkit.messageHandlers.payMent.postMessage(orderNum)
  }
  // 打开浏览器
  openBrowser(url: string) {
    window.webkit.messageHandlers.openBrowser.postMessage(url)
  }
  onLogin() {
    window.webkit.messageHandlers.onLogin.postMessage('') // 默认无参数时需要空字符串
  }
  setAppStorage(payload: string) {
    try {
      window.webkit.messageHandlers.setAppStorage.postMessage(payload)
    } catch (error) {
      console.log('setAppStorage', error)
    }
  }
  getNFAppVersion(): Promise<string> {
    return new Promise((resolve) => {
      window.setNFAppVersion = (version: string) => {
        resolve(version)
      }
      if (!window.webkit.messageHandlers.getNFAppVersion) {
        resolve('')
      }
      window.webkit.messageHandlers.getNFAppVersion.postMessage('')
    })
  }
  openMiniProgram(id: string, path: string, version: NFProgrameVersions) {
    window.webkit.messageHandlers.openMiniProgram.postMessage(
      JSON.stringify({
        id,
        path,
        version,
      })
    )
  }
  getAppBaseInfo(): Promise<AppBaseInfoType> {
    return new Promise((resolve) => {
      window.responseAppBaseInfo = (data: string) => {
        resolve(parseAppBaseInfo(data))
      }
      if (!window.webkit.messageHandlers.getAppBaseInfo) {
        resolve(null)
      }
      window.webkit.messageHandlers.getAppBaseInfo.postMessage('')
    })
  }
  getFaultReportCache(): Promise<string> {
    return new Promise((resolve) => {
      window.setFaultReportCache = (data: string) => {
        resolve(data)
      }
      if (!window.webkit.messageHandlers.getFaultReportCache) {
        resolve('')
      }
      window.webkit.messageHandlers.getFaultReportCache.postMessage('')
    })
  }
  deleteFaultReport(id: string): undefined {
    if (!window.webkit.messageHandlers.deleteFaultReport) {
      return undefined
    }
    window.webkit.messageHandlers.deleteFaultReport.postMessage(id)
  }
  getFaultReportImage(key: string): Promise<string> {
    return new Promise((resolve) => {
      if (!window.webkit.messageHandlers.getFaultReportImage) {
        resolve('')
      }
      window.setFaultReportImage = (data: string) => {
        resolve('data:image/png;base64,' + data)
      }

      window.webkit.messageHandlers.getFaultReportImage.postMessage(key)
    })
  }
  setOfflinePageEnable(enable = false): Promise<void> {
    return new Promise((resolve) => {
      if (!window.webkit.messageHandlers.setOfflinePageEnable) {
        resolve(undefined)
      }
      window.webkit.messageHandlers.setOfflinePageEnable.postMessage(enable)
    })
  }
  getDisplayMode(): Promise<string> {
    return new Promise((resolve) => {
      window.responseGetDisplayMode = (mode: string) => {
        resolve(mode)
      }
      if (!window.webkit.messageHandlers.getDisplayMode) {
        resolve('')
      }
      window.webkit.messageHandlers.getDisplayMode.postMessage('')
    })
  }
  getLandscapeScreenSafeArea(): Promise<LandscapeScreenSafeAreaInfo> {
    return new Promise((resolve) => {
      window.responseLandscapeScreenSafeArea = (data: string) => {
        resolve(parseLandscapeInfo(data))
      }
      if (!window.webkit.messageHandlers.getLandscapeScreenSafeArea) {
        resolve(null)
      }
      window.webkit.messageHandlers.getLandscapeScreenSafeArea.postMessage('')
    })
  }
  openCameraToScanQrCode(title: string): Promise<string> {
    return new Promise((resolve) => {
      window.onOpenCameraToScanQrCodeResponse = (result: string) => {
        resolve(result)
      }
      window.webkit.messageHandlers.openCameraToScanQrCode.postMessage(title)
    })
  }

  openNewPage(params: OpenNewPageParams) {
    if (!window.webkit.messageHandlers.openNewPage) {
      return Promise.resolve(undefined)
    }
    return window.webkit.messageHandlers.openNewPage.postMessage(params)
  }
  saveImage(str: string): Promise<string> {
    console.log('str', str.slice(0, 20))
    return new Promise((resolve, reject) => {
      if (!window.webkit.messageHandlers.saveImage) {
        resolve(undefined)
      }
      window.responseSaveImageSuccess = (data: string) => {
        resolve(data || '保存成功')
      }
      window.responseSaveImageFail = (data: string) => {
        console.log('data', data)
        reject(data || '保存失败')
      }
      window.webkit.messageHandlers.saveImage.postMessage(str)
    })
  }
  shareAction(option: ShareActionOption): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!window.webkit.messageHandlers.shareAction) {
        resolve(undefined)
      }
      try {
        window.responseShareActionSuccess = (data: string) => {
          resolve(undefined)
        }
        window.responseShareActionFail = (data: string) => {
          console.log('data', data)
          reject(data || '保存失败')
        }
        window.webkit.messageHandlers.shareAction.postMessage(option)
      } catch (error) {
        console.log('erro11r', error)
      }
    })
  }
  // 分享到朋友圈
  shareToMoments(params: ShareToWeChatParams) {}
  // 分享到微信
  shareToWeChat(params: ShareToWeChatParams): void {}
}

function getHost(): IHost {
  if (isAndrod) {
    return new AndroidApp()
  }
  if (isIos) {
    return new IosApp()
  }
  return getHostApp()
}
export function initBaseGlobalHeaderInfo(): void {
  let system = ''
  const miniValue = getGlobelHeader(MINIKEY)
  if (isIos) {
    system = 'ios'
  } else if (isAndrod) {
    system = 'android'
  } else if (miniValue) {
    system = 'applet'
  }
  let application = 'browser'
  if (isAgriApp) {
    application = 'agri'
  } else if (isFarm2App) {
    application = 'farm'
  } else if (isFarm3App) {
    application = 'xfarm'
  } else if (isXapcTabLet) {
    application = 'xapc4'
  } else if (isXapc) {
    application = 'xapc'
  } else if (isXapc4) {
    application = 'xapc4'
  } else if (isXagarApp) {
    application = 'car'
  } else if (miniValue) {
    application = 'miniValue'
  }
  setGlobelHeader('system', system)
  setGlobelHeader('application', application)
}

export default getHost()
